<div class="info-message"><span data-automation="confirmation_message">{{ 'EMPLOYEE_PAYS.ACTION_CONFIRMATION_POPUP_SUMMARY_MESSAGE' | translate:{numItems:
    resultsInfo.totalNumberOfItems} }}</span></div>
<ng-container *ngIf="resultsInfo.successfulNumberOfItems > 0">
  <p *ngIf="!resultsInfo.isCancelStop"
    [innerHtml]="'EMPLOYEE_PAYS.ACTION_CONFIRMATION_POPUP_SUCCESSFUL_DETAILS' | translate">
  </p>
  <ul *ngIf="!resultsInfo.isCancelStop" class="popup-ul">
    <li *ngIf="resultsInfo.hasSuccessfulCheck"
      [innerHtml]="'EMPLOYEE_PAYS.ACTION_CONFIRMATION_POPUP_SUCCESSFUL_CHECK_DETAILS' | translate">
    </li>
    <li *ngIf="resultsInfo.hasSuccessfulDirectDeposit"
      [innerHtml]="'EMPLOYEE_PAYS.ACTION_CONFIRMATION_POPUP_SUCCESSFUL_DD_DETAILS' | translate">
    </li>
  </ul>
  <div *ngIf="!resultsInfo.isCancelStop" class="info-message">
    <span data-automation="confirmation_message">{{ 'EMPLOYEE_PAYS.ACTION_CONFIRMATION_POPUP_SUCCESSFUL_STOP_MESSAGE' | translate:{numItems:
      resultsInfo.successfulNumberOfItems} }}</span>
  </div>
  <div *ngIf="resultsInfo.isCancelStop" class="info-message">
    <span data-automation="confirmation_message">{{ 'EMPLOYEE_PAYS.ACTION_CONFIRMATION_POPUP_SUCCESSFUL_CANCEL_STOP_MESSAGE' | translate:{numItems:
      resultsInfo.successfulNumberOfItems} }}</span>
  </div>
  <div>
    <ng-container [ngTemplateOutlet]="actionResultsSuccessfulTemplate"
      [ngTemplateOutletContext]="{'datasource': resultsInfo.successfulItems}"></ng-container>
  </div>
</ng-container>
<ng-container *ngIf="resultsInfo.unsuccessfulNumberOfItems > 0">
  <div class="info-message">
    <span class="icon-text" translate [translateParams]="{numItems: resultsInfo.unsuccessfulNumberOfItems}">
      <ukg-icon name="warning" color="important"></ukg-icon>&nbsp;EMPLOYEE_PAYS.ACTION_CONFIRMATION_POPUP_ERROR_MESSAGE
    </span>
  </div>
  <ng-container [ngTemplateOutlet]="actionResultsUnsuccessfulTemplate"
    [ngTemplateOutletContext]="{'datasource': resultsInfo.unsuccessfulItems}"></ng-container>
</ng-container>

<ng-template #actionResultsSuccessfulTemplate let-datasource="datasource">
  <div class="pay-table-container flex-row">
    <div class="flex-fill flex-row">
      <div class="flex-0-0-100">

        <ukg-data-table-container>
          <ukg-data-table [columnNames]="successfulColumns">
            <table id="table">
              <thead id="head">
                <tr>
                  <ng-container data-automation="pay-action-successful-results-table-column-displayName">
                    <ukg-th style="width:20%" data-automation="pay-action-successful-results-table-header-displayName">
                      <span data-automation="pay-action-successful-results-table-header-displayName-label" translate>
                        EMPLOYEE_PAYS.COLUMN_NAME</span>
                    </ukg-th>
                  </ng-container>
                  <ng-container data-automation="pay-action-successful-results-table-column-payUtcDate">
                    <ukg-th style="width:10%" data-automation="pay-action-successful-results-table-header-payUtcDate">
                      <span data-automation="pay-action-successful-results-table-header-payUtcDate-label" translate>
                        EMPLOYEE_PAYS.COLUMN_PAY_DATE</span>
                    </ukg-th>
                  </ng-container>
                  <ng-container data-automation="pay-action-successful-results-table-column-paymentType">
                    <ukg-th style="width:12%" data-automation="pay-action-successful-results-table-header-paymentType">
                      <span data-automation="pay-action-successful-results-table-header-paymentType-label"
                        translate>EMPLOYEE_PAYS.COLUMN_PAYMENT_TYPE</span>
                    </ukg-th>
                  </ng-container>
                  <ng-container data-automation="pay-action-successful-results-table-column-itemAmount">
                    <ukg-th style="width:13%" data-automation="pay-action-successful-results-table-header-itemAmount">
                      <span data-automation="pay-action-successful-results-table-header-itemAmount-label"
                        translate>EMPLOYEE_PAYS.COLUMN_ITEM_AMOUNT</span>
                    </ukg-th>
                  </ng-container>
                  <ng-container data-automation="pay-action-successful-results-table-column-statusText">
                    <ukg-th style="width:15%" data-automation="pay-action-successful-results-table-header-statusText">
                      <span data-automation="pay-action-successful-results-table-header-statusText-label"
                        translate>EMPLOYEE_PAYS.COLUMN_STATUS</span>
                    </ukg-th>
                  </ng-container>
                  <ng-container data-automation="pay-action-successful-results-table-column-reasonCode">
                    <ukg-th style="width:30%" data-automation="pay-action-successful-results-table-header-reasonCode">
                      <span data-automation="pay-action-successful-results-table-header-reasonCode-label"
                        translate>EMPLOYEE_PAYS.COLUMN_REASON_CODE</span>
                    </ukg-th>
                  </ng-container>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let resultsData of datasource; let i = index">
                  <tr>
                    <td data-automation="pay-action-successful-results-table-row-displayName">
                      <span (mouseenter)="resultsDataDisplayName.present($event.target)"
                        (mouseleave)="resultsDataDisplayName.dismiss()">
                          {{resultsData.displayName | truncate:30}}
                      </span>
                      <ukg-popover #resultsDataDisplayName position="top">{{resultsData.displayName}}</ukg-popover>
                    </td>
                    <td data-automation="pay-action-successful-results-table-row-payUtcDate">
                      <span data-automation="pay-action-successful-results-table-row-payUtcDate-content"
                        class="cell-content" 
                        (mouseenter)="resultsDataPayDate.present($event.target)"
                        (mouseleave)="resultsDataPayDate.dismiss()">
                          {{resultsData.pay.payUtcDate | ultishortdate: 'L'}}
                      </span>
                      <ukg-popover #resultsDataPayDate position="top">{{resultsData.pay.payUtcDate | ultishortdate: 'L'}}</ukg-popover>
                    </td>
                    <td data-automation="pay-action-successful-results-table-row-paymentType">
                      <span data-automation="pay-action-successful-results-table-row-paymentType-content"
                        class="cell-content"
                        (mouseenter)="resultsDataPaymentType.present($event.target)"
                        (mouseleave)="resultsDataPaymentType.dismiss()">
                          {{getPaymentTypeTextKey(resultsData.item.paymentType) | translate | truncate:15}}
                      </span>
                      <ukg-popover #resultsDataPaymentType position="top">{{getPaymentTypeTextKey(resultsData.item.paymentType) | translate}}</ukg-popover>
                    </td>
                    <td data-automation="pay-action-successful-results-table-row-itemAmount">
                      <span data-automation="pay-action-successful-results-table-row-itemAmount-content"
                        class="cell-content nowrap" 
                        (mouseenter)="resultsDataItemAmount.present($event.target)"
                        (mouseleave)="resultsDataItemAmount.dismiss()">
                          {{resultsData.item.amount | ulticurrency:'1.02':undefined:true}}
                      </span>
                      <ukg-popover #resultsDataItemAmount position="top">{{resultsData.item.amount | ulticurrency:'1.02':undefined:true}}</ukg-popover>
                    </td>
                    <td data-automation="pay-action-successful-results-table-row-statusText"
                      [ngClass]="{ 'text-danger': isStatusError(resultsData.item.lastKnownStatus), 'text-warning': isStatusWarning(resultsData.item.lastKnownStatus) }">
                      <div class="result-content"
                        (mouseenter)="resultsDataStatus.present($event.target)"
                        (mouseleave)="resultsDataStatus.dismiss()"    
                        data-automation="pay-action-successful-results-table-row-statusText-content">
                        <ukg-icon class="danger-icon" name="status-disabled" *ngIf="isStatusError(resultsData.item.lastKnownStatus)"
                          data-automation="pay-action-successful-results-table-row-statusText-error-icon">
                        </ukg-icon>

                        <ukg-icon class="warning-icon" name="warning" *ngIf="isStatusWarning(resultsData.item.lastKnownStatus)"
                          data-automation="pay-action-successful-results-table-row-statusText-warning-icon">
                        </ukg-icon>
                        {{getStatusTextKey(resultsData.item.lastKnownStatus) | translate | truncate:30}}
                      </div>
                      <ukg-popover #resultsDataStatus position="top">{{getStatusDescriptionKey(resultsData.item.lastKnownStatus) | translate}}</ukg-popover>
                    </td>
                    <td data-automation="pay-action-successful-results-table-row-reasonCode">
                      <span data-automation="pay-action-successful-results-table-row-reasonCode-content"
                        class="cell-content" 
                        (mouseenter)="resultsDataReasonCode.present($event.target)"
                        (mouseleave)="resultsDataReasonCode.dismiss()">
                          {{translateBankNotificationCode(resultsData.reasonCode) | translate | truncate:30}}
                      </span>
                      <ukg-popover #resultsDataReasonCode position="top">{{translateBankNotificationCode(resultsData.reasonCode)}}</ukg-popover>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </ukg-data-table>
        </ukg-data-table-container>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #actionResultsUnsuccessfulTemplate let-datasource="datasource">
  <div class="pay-table-container flex-row">
    <div class="flex-fill flex-row">
      <div class="flex-0-0-100">
        <ukg-data-table-container>
          <ukg-data-table [columnNames]="unsuccessfulColumns">
            <table id="table">
              <thead id="head">
                <tr>
                  <ng-container data-automation="pay-action-unsuccessful-results-table-column-displayName">
                    <ukg-th style="width:20%"
                      data-automation="pay-action-unsuccessful-results-table-header-displayName"><span
                        data-automation="pay-action-unsuccessful-results-table-header-displayName-label"
                        translate>EMPLOYEE_PAYS.COLUMN_NAME</span>
                    </ukg-th>
                  </ng-container>
                  <ng-container data-automation="pay-action-unsuccessful-results-table-column-payItemAmount">
                    <ukg-th style="width:13%"
                      data-automation="pay-action-unsuccessful-results-table-header-payItemAmount"><span
                        data-automation="pay-action-unsuccessful-results-table-header-payItemAmount-label"
                        translate>EMPLOYEE_PAYS.COLUMN_ITEM_AMOUNT</span></ukg-th>
                  </ng-container>
                  <ng-container data-automation="pay-action-unsuccessful-results-table-column-statusText">
                    <ukg-th style="width:15%" data-automation="pay-action-unsuccessful-results-table-header-statusText">
                      <span data-automation="pay-action-unsuccessful-results-table-header-statusText-label" translate>
                        EMPLOYEE_PAYS.COLUMN_STATUS</span>
                    </ukg-th>
                  </ng-container>
                  <ng-container data-automation="pay-action-unsuccessful-results-table-column-resultCode"
                    class="reason-code-header-cell">
                    <ukg-th style="width:52%" data-automation="pay-action-unsuccessful-results-table-header-resultCode">
                      <span data-automation="pay-action-unsuccessful-results-table-header-resultCode-label"
                        translate>EMPLOYEE_PAYS.COLUMN_ERROR_REASON</span>
                    </ukg-th>
                  </ng-container>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let Unsuccessfulldata of datasource; let i = index">
                  <tr>
                    <td data-automation="pay-action-unsuccessful-results-table-row-displayName">
                      <span class="cell-content"
                        data-automation="pay-action-unsuccessful-results-table-row-displayName-content"
                        (mouseenter)="unsuccessfulDataDisplayName.present($event.target)"
                        (mouseleave)="unsuccessfulDataDisplayName.dismiss()">
                          {{Unsuccessfulldata.displayName | truncate:30}}
                      </span>
                      <ukg-popover #unsuccessfulDataDisplayName position="top">{{Unsuccessfulldata.displayName}}</ukg-popover>
                    </td>
                    <td data-automation="pay-action-unsuccessful-results-table-row-payItemAmount">
                      <span data-automation="pay-action-unsuccessful-results-table-row-payItemAmount-content"
                        class="cell-content nowrap"
                        (mouseenter)="unsuccessfulDataItemAmount.present($event.target)"
                        (mouseleave)="unsuccessfulDataItemAmount.dismiss()">
                          {{Unsuccessfulldata.item.amount | ulticurrency:'1.02':undefined:true}}
                      </span>
                      <ukg-popover #unsuccessfulDataItemAmount position="top">{{Unsuccessfulldata.item.amount | ulticurrency:'1.02':undefined:true}}</ukg-popover>
                    </td>
                    <td data-automation="pay-action-unsuccessful-results-table-row-statusText"
                      [ngClass]="{ 'text-danger': isStatusError(Unsuccessfulldata.item.lastKnownStatus), 'text-warning': isStatusWarning(Unsuccessfulldata.item.lastKnownStatus) }">
                      <div class="result-content" 
                        data-automation="pay-action-unsuccessful-results-table-row-statusText-content" 
                        (mouseenter)="unsuccessfulDataStatus.present($event.target)"
                        (mouseleave)="unsuccessfulDataStatus.dismiss()">
                        <ukg-icon class="danger-icon" name="status-disabled" *ngIf="isStatusError(Unsuccessfulldata.item.lastKnownStatus)"
                          data-automation="pay-action-successful-results-table-row-statusText-error-icon">
                        </ukg-icon>

                        <ukg-icon class="warning-icon" name="warning" *ngIf="isStatusWarning(Unsuccessfulldata.item.lastKnownStatus)"
                          data-automation="pay-action-successful-results-table-row-statusText-warning-icon">
                        </ukg-icon>
                        {{getStatusTextKey(Unsuccessfulldata.item.lastKnownStatus) | translate | truncate:30}}
                      </div>
                      <ukg-popover #unsuccessfulDataStatus position="top">{{getStatusDescriptionKey(Unsuccessfulldata.item.lastKnownStatus) | translate}}</ukg-popover>
                    </td>
                    <td data-automation="pay-action-unsuccessful-results-table-row-resultCode">
                      <span data-automation="pay-action-unsuccessful-results-table-row-resultCode-content"
                        class="cell-content" placement="top"
                        triggers="mouseenter:mouseleave">{{translateError(Unsuccessfulldata)}}</span>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </ukg-data-table>
        </ukg-data-table-container>
      </div>
    </div>
  </div>
</ng-template>
